import { evenWeights, weightsFor } from "./tasks";
import { DISTRIBUTION_PLATFORMS, type PlatformWeight } from "../types";

const KEY = "mediadesk.find-prefs";

export interface FindPrefs {
  count: number;
  platforms: string[];
  weights: PlatformWeight[];
}

const FALLBACK: FindPrefs = {
  count: 10,
  platforms: ["小红书"],
  weights: [{ platform: "小红书", weight: 100 }],
};

function browserStore(): { getItem(key: string): string | null; setItem(key: string, value: string): void } | null {
  const host = globalThis as { localStorage?: { getItem(key: string): string | null; setItem(key: string, value: string): void } };
  return host.localStorage ?? null;
}

export function readFindPrefs(): FindPrefs {
  try {
    const raw = browserStore()?.getItem(KEY);
    if (!raw) return FALLBACK;
    return normalizeFindPrefs(JSON.parse(raw));
  } catch {
    return FALLBACK;
  }
}

export function writeFindPrefs(input: FindPrefs): FindPrefs {
  const next = normalizeFindPrefs(input);
  try {
    browserStore()?.setItem(KEY, JSON.stringify(next));
  } catch {
    /* private mode */
  }
  return next;
}

export function normalizeFindPrefs(value: unknown): FindPrefs {
  const raw = value && typeof value === "object" ? (value as Partial<FindPrefs>) : {};
  const count = typeof raw.count === "number" && raw.count >= 1 && raw.count <= 100 ? Math.round(raw.count) : FALLBACK.count;
  const platforms = Array.isArray(raw.platforms)
    ? raw.platforms.filter((item): item is string => typeof item === "string" && (DISTRIBUTION_PLATFORMS as readonly string[]).includes(item))
    : [];
  const selected = platforms.length ? platforms : FALLBACK.platforms;
  return {
    count,
    platforms: selected,
    weights: weightsFor(selected, Array.isArray(raw.weights) ? raw.weights : evenWeights(selected)),
  };
}
